const APP_LOADER_ID = 'app-loader';
const APP_LOADER_HIDDEN_CLASS = 'app-loader--hidden';

function getAppLoader(): HTMLElement | null {
  return document.getElementById(APP_LOADER_ID);
}

export function showAppLoader(label?: string): void {
  const loader = getAppLoader();
  if (loader === null) return;

  if (label !== undefined) {
    const labelElement = loader.querySelector<HTMLElement>(
      '[data-app-loader-label]',
    );
    if (labelElement) labelElement.textContent = label;
  }

  loader.removeAttribute('aria-hidden');
  loader.classList.remove(APP_LOADER_HIDDEN_CLASS);
}

export function hideAppLoader(): void {
  const loader = getAppLoader();
  if (loader === null) return;

  loader.setAttribute('aria-hidden', 'true');
  loader.classList.add(APP_LOADER_HIDDEN_CLASS);
}
